import { render, staticRenderFns } from "./CardServe.vue?vue&type=template&id=ac8fb5f8&scoped=true&"
import script from "./CardServe.vue?vue&type=script&lang=js&"
export * from "./CardServe.vue?vue&type=script&lang=js&"
import style0 from "./CardServe.vue?vue&type=style&index=0&id=ac8fb5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8fb5f8",
  null
  
)

export default component.exports